module.exports = __webpack_public_path__ + "static/media/ic_close.bd0f387e.svg";